export default "__VITE_ASSET__qTT4UOYJ__"